// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"ya_fyC"};